<script setup lang="ts">
const props = defineProps<{
  description: string
}>()
const { t } = useI18n()
const isExpanded = ref(false)
</script>

<template>
  <RdxCollapsibleRoot
    v-model:open="isExpanded"
    class="w-full"
  >
    <div class="relative overflow-hidden">
      <div
        class="text-sm text-gray-700"
        :class="!isExpanded ? 'max-h-[100px] overflow-hidden' : ''"
      >
        <div
          class="overflow-hidden prose [&_table]:block [&_table]:max-w-full [&_table]:overflow-x-auto"
          v-html="props.description"
        />
      </div>
      <div
        v-if="!isExpanded"
        class="pointer-events-none absolute bottom-0 left-0 h-15 w-full from-white to-transparent bg-gradient-to-t"
      />
    </div>

    <RdxCollapsibleTrigger
      class="mx-auto mt-1 flex items-center justify-center rounded-full bg-error px-2 py-1 text-sm text-white font-medium fw600"
    >
      <span>
        {{
          isExpanded
            ? t('product.description.show_less_button.label')
            : t('product.description.show_more_button.label')
        }}
      </span>
      <Icon name="i-heroicons:chevron-down-16-solid" :class="{ 'rotate-180': isExpanded }" />
    </RdxCollapsibleTrigger>
  </RdxCollapsibleRoot>
</template>
